import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment-timezone';
import { ContractService, ViolationReportService } from 'src/app/core/services';
import { ComponentModal, Lane, Reason, Regulation, Spot } from '../../../../../../core/models';
// eslint-disable-next-line max-len
import { ViolationReportByDateModalComponent } from '../../../../../../modals/violation-report-by-date-modal/violation-report-by-date-modal.component';
import { ModalService, SpotService } from '../../../../../../core/services';
// eslint-disable-next-line max-len
import { ViolationReportDetailsModalComponent } from '../../../../../../modals/violation-report-details-modal/violation-report-details-modal.component';

@Component({
  selector: 'app-violations-report-view',
  templateUrl: './view-table.component.html',
  styleUrls: ['./view-table.component.sass']
})
export class ViewTableComponent implements OnInit, OnDestroy {
  public loading = true;
  public contractCode = '';
  public contractName = '';

  public tree: any = null;
  public allCollapse = true;

  public contractDataViolationsSub: Subscription;
  public contractViolationsSub: Subscription;
  public filterSub: Subscription;

  public filterParam: any = {
    spotsIds: [], laneIds: [], regulationsIds: [], situationsIds: [], reasonsIds: [], hideLanes: true
  };

  public params: any = {};
  public contractId: string = null;
  public startDate: string = moment().format('YYYY-MM-DD');
  public endDate: string = moment().format('YYYY-MM-DD');

  public regulations: Regulation[] = [];
  public lanes: Lane[] = [];
  public spots: Spot[] = [];
  public reasons: Reason[] = [];
  public timezone: string = null;

  constructor(
    private violationReportService: ViolationReportService,
    private route: ActivatedRoute,
    private router: Router,
    private contractService: ContractService,
    private modalService: ModalService,
    private spotService: SpotService
  ) { }

  async ngOnInit() {
    this.loading = true;

    this.filterSub = this.violationReportService.getFilterParamsViolationReport()
      .pipe(filter(result => Object.keys(result).length > 0))
      .subscribe((data: any) => {
        this.filterParam.spotsIds = (data.spotsIds || []).map(Number);
        this.filterParam.laneIds = (data.laneIds || []).map(Number);
        this.filterParam.regulationsIds = data.regulationsIds || [];
        this.filterParam.situationsIds = data.situationsIds || [];
        this.filterParam.reasonsIds = data.reasonsIds || [];
      });

    this.contractDataViolationsSub = await this.violationReportService.getContractDataViolationReport()
      .subscribe(async (data: any) => {
        this.regulations = data.regulations;
        this.lanes = data.lanes;
        this.spots = data.spots;
        this.reasons = data.reasons;
        this.timezone = data.timezone || null;

        if (data && data.contractId) {
          this.contractId = data.contractId;
          await this.contractService.getById(data.contractId).then(contract => {
            this.contractCode = contract.code;
            this.contractName = contract.name;
          });

          this.setParams();

          if (localStorage.getItem('ViewTableParams')) {
            localStorage.removeItem('ViewTableParams');
          }

          if (localStorage.getItem('ViewTable-date[between]')) {
            localStorage.removeItem('ViewTable-date[between]');
          }

          await this.getViolations();
        }
      });
  }

  async getViolations() {
    this.loading = true;
    this.tree = await this.violationReportService.reportViolationCounter(this.params);
    this.loading = false;

    if (this.tree && Object.keys(this.tree).length > 0) {
      this.violationReportService.emitContractViolationReport(this.flattenTreeForExport(this.tree));
      this.tree = this.injectCollapseState(this.tree);
    } else {
      this.tree = null;
    }
  }

  setParams() {
    const now = new Date().toISOString();
    this.params.contractId = this.contractId;
    this.params.pageSize = 50;
    if (this.timezone) {
      this.params.startDate = moment.tz(moment(now).subtract(7, 'days').format('YYYY-MM-DD') + ' 00:00:00', this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      this.params.endsDate = moment.tz(moment(now).format('YYYY-MM-DD') + ' 23:59:59', this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
    } else {
      this.params.startDate = moment(now).subtract(7, 'days').utc().format().split('T')[0];
      this.params.endsDate = moment(this.endDate).format('YYYY-MM-DD');
    }

    document.addEventListener('periodViolationReport', (e: CustomEvent) => {
      if (this.timezone) {
        this.params.startDate = moment.tz(moment(e.detail.startDate).format('YYYY-MM-DD HH:mm:ss'), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
        this.params.endsDate = moment.tz(moment(e.detail.endDate).format('YYYY-MM-DD HH:mm:ss'), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.params.startDate = e.detail.startDate.split('T')[0];
        this.params.endsDate = e.detail.endDate.split('T')[0];
      }
      localStorage.setItem('ViewTable-date[between]', `[${e.detail.startDate},${e.detail.endDate}]`);
      localStorage.setItem('ViewTableParams', JSON.stringify(this.params));
      this.getViolations();
    });

    document.addEventListener('searchFilterEvent', () => {
      delete this.params.laneCode;
      this.params.spotsIds = this.filterParam.spotsIds;
      this.params.laneIds = this.filterParam.laneIds;
      this.params.regulationsIds = this.filterParam.regulationsIds;
      this.params.situationsIds = this.filterParam.situationsIds;
      const reasonIds = (this.filterParam.reasonsIds || []).map(Number);
      const reasonsCodes = this.reasons.filter(r => reasonIds.includes(Number(r.id))).map(r => r.code);
      this.params.reasonsIds = reasonsCodes.length > 0 ? reasonsCodes : [];
      localStorage.setItem('ViewTableParams', JSON.stringify(this.params));
      this.getViolations();
    });
  }

  injectCollapseState(node: any) {
    node.collapse = true;
    if (node.spots) {
      node.spots.forEach((s: any) => {
        s.collapse = true;
        if (s.lanes) {
          s.lanes.forEach((l: any) => {
            l.collapse = true;
            if (l.regulations) {
              l.regulations.forEach((r: any) => {
                r.collapse = true;
                if (r.reasons) {
                  r.reasons.forEach((rs: any) => rs.collapse = true);
                }
              });
            }
          });
        }
      });
    }
    return node;
  }

  toggleCollapse(item: any) {
    item.collapse = !item.collapse;
  }

  toggleAllCollapse() {
    this.allCollapse = !this.allCollapse;
    if (this.tree && this.tree.spots) {
      this.tree.spots.forEach((spot: any) => {
        spot.collapse = this.allCollapse;
      });
    }
  }

  formatQty(value: number, total: number): string {
    if (!total || total === 0) { return '0'; }
    if (!value || value === 0) { return '0'; }
    const percentage = ((value / total) * 100).toFixed(2);
    return `${value}/${percentage}%`;
  }

  getProgressWidth(value: number, total: number): string {
    if (!total || total === 0) { return '0%'; }
    return ((value / total) * 100).toFixed(2) + '%';
  }

  async filterNavigate(target: string, situation = null, regulation = null, spot = null, lane = null, reason = null) {
    const data: any = {
      situationsIds: situation ? [situation] : (this.filterParam?.situationsIds ? [...this.filterParam.situationsIds] : []),
      spotsIds: spot ? [spot] : (this.filterParam?.spotsIds ? [...this.filterParam.spotsIds] : []),
      laneIds: lane ? [lane] : (this.filterParam?.laneIds ? [...this.filterParam.laneIds] : []),
      regulationsIds: regulation ? [regulation] : (this.filterParam?.regulationsIds ? [...this.filterParam.regulationsIds] : []),
      reasonsIds: reason ? [reason] : (this.filterParam?.reasonsIds ? [...this.filterParam.reasonsIds] : [])
    };

    if (reason && !data.situationsIds.includes('invalid')) {
      data.situationsIds.push('invalid');
    }

    const queryParams: any = {};
    queryParams.order = 'date';

    let lanesCode: string[] = [];

    if (data.spotsIds && data.spotsIds.length > 0) {
      const lanesWithSpot = [...new Set(this.lanes.filter(l => data.spotsIds.includes(l.spotId)).map(l => l.code))];
      if (lanesWithSpot.length > 0) {
        lanesCode = lanesWithSpot;
      }

      try {
        const fetchedSpot = await this.spotService.getById(data.spotsIds[0]);
        queryParams.spotCode = fetchedSpot.code;
      } catch (err) {
        console.log(err);
      }
    }

    if (data.laneIds && data.laneIds.length > 0) {
      const laneIdsAsString = data.laneIds.map(String);
      lanesCode = [...new Set(this.lanes.filter(l => laneIdsAsString.includes(String(l.id))).map(l => l.code))];
    }

    if (lanesCode.length > 0) {
      queryParams['laneCode[in]'] = `[${lanesCode.join()}]`;
    }

    if (data.regulationsIds && data.regulationsIds.length > 0) {
      queryParams['regulationId[in]'] = `[${data.regulationsIds.join()}]`;
    }

    if (data.situationsIds && data.situationsIds.length > 0) {
      if (data.situationsIds.length === 1 && data.situationsIds.includes('inProcess')) {
        queryParams['step[notIn]'] = `[done,lotAttribution]`;
      } else if (data.situationsIds.length > 1 && data.situationsIds.includes('inProcess')) {
        queryParams['status[in]'] = `[invalid,valid]`;
      } else if (!data.situationsIds.includes('inProcess')) {
        queryParams['status[in]'] = `[${data.situationsIds.join()}]`;
        queryParams['step[in]'] = `[lotAttribution,done]`;
      }
    }

    if (
      data.reasonsIds && data.reasonsIds.length > 0 && data.situationsIds.includes('invalid') &&
      (!this.reasons || data.reasonsIds.length < this.reasons.length)) {
      const reasonIds = data.reasonsIds.map(Number);
      const reasonsCode = this.reasons.filter(r => reasonIds.includes(Number(r.id))).map(r => r.code);
      if (reasonsCode.length > 0) {
        queryParams['reason.code[in]'] = `[${reasonsCode.join(',')}]`;
      }
    }

    let dateBetween: string;
    if (this.timezone) {
      dateBetween = `[${this.params.startDate},${this.params.endsDate}]`;
    } else {
      dateBetween = `[${this.params.startDate} 00:00:00,${this.params.endsDate} 23:59:59]`;
    }

    if (target === 'details') {
      this.modalService.show(new ComponentModal(ViolationReportDetailsModalComponent, {
        params: {
          contractId: this.contractId,
          'date[between]': dateBetween,
          ...queryParams
        }
      }))
        .then(() => { })
        .catch(() => null);
    }

    if (target === 'by-date') {
      this.modalService.show(new ComponentModal(ViolationReportByDateModalComponent, {
        params: {
          contractId: this.contractId,
          'date[between]': dateBetween,
          ...(this.timezone ? { timezone: this.timezone } : {}),
          ...queryParams
        }
      }))
        .then(() => { })
        .catch(() => null);
    }
  }

  ngOnDestroy() {
    if (this.contractDataViolationsSub) { this.contractDataViolationsSub.unsubscribe(); }
    if (this.contractViolationsSub) { this.contractViolationsSub.unsubscribe(); }
    if (this.filterSub) { this.filterSub.unsubscribe(); }
  }

  private flattenTreeForExport(tree: any): any[] {
    if (tree.exportRows?.length > 0) {
      return this.expandExportRows(tree.exportRows);
    }
    const rows: any[] = [];
    for (const spot of tree.spots || []) {
      for (const lane of spot.lanes || []) {
        for (const reg of lane.regulations || []) {
          const base = {
            spotCode: spot.spotCode, spotId: spot.spotId,
            laneCode: lane.laneCode, laneId: lane.laneId,
            regulation: reg.regulationCode
          };
          const inProcessQty = (reg.total || 0) - (reg.validQuantity || 0) - (reg.invalidQuantity || 0);
          if (inProcessQty > 0) {
            rows.push({ ...base, type: 'inProcess', value: inProcessQty, reasonCode: '', reasonName: '' });
          }
          if ((reg.validQuantity || 0) > 0) {
            rows.push({ ...base, type: 'valid', value: reg.validQuantity, reasonCode: '', reasonName: '' });
          }
          if ((reg.reasons || []).length > 0) {
            for (const reason of reg.reasons) {
              if ((reason.total || 0) > 0) {
                // eslint-disable-next-line max-len
                rows.push({ ...base, type: 'invalid', value: reason.total, reasonCode: reason.reasonCode, reasonName: reason.reasonDescription });
              }
            }
          } else if ((reg.invalidQuantity || 0) > 0) {
            rows.push({ ...base, type: 'invalid', value: reg.invalidQuantity, reasonCode: '', reasonName: '' });
          }
        }
      }
    }
    return rows;
  }

  private expandExportRows(exportRows: any[]): any[] {
    const rows: any[] = [];
    for (const row of exportRows) {
      if (row.inProcessQty > 0) {
        // eslint-disable-next-line max-len
        rows.push({ value: row.inProcessQty, date: row.date, regulation: row.regulationCode, laneId: row.laneId, laneCode: row.laneCode, spotId: row.spotId, spotCode: row.spotCode, type: 'inProcess', reasonCode: '', reasonName: '' });
      }
      if (row.validQty > 0) {
        // eslint-disable-next-line max-len
        rows.push({ value: row.validQty, date: row.date, regulation: row.regulationCode, laneId: row.laneId, laneCode: row.laneCode, spotId: row.spotId, spotCode: row.spotCode, type: 'valid', reasonCode: '', reasonName: '' });
      }
      if (row.invalidQty > 0) {
        // eslint-disable-next-line max-len
        rows.push({ value: row.invalidQty, date: row.date, regulation: row.regulationCode, laneId: row.laneId, laneCode: row.laneCode, spotId: row.spotId, spotCode: row.spotCode, type: 'invalid', reasonCode: row.reasonCode || '', reasonName: row.reasonName || '' });
      }
    }
    return rows;
  }
}
